import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable} from "rxjs";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";
import {LicensedAgent} from "../interface/licensed-agent";

@Injectable({
  providedIn: 'root'
})
export class AffiliateCodeService {

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public send(formData: object, uuid?: string): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/affiliate-code/${uuid}`, formData)
        .pipe(take(1))
        ;
    } else {
        return this.httpClient.post('/rest/crm/affiliate-code', formData)
          .pipe(take(1))
          ;
    }
  }


  public delete(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/affiliate-code/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

  public restore(uuid: string): Observable<Uuid>  {
    return this.httpClient.put(`/rest/crm/affiliate-code/${uuid}/restore`, {})
      .pipe(first()) as Observable<Uuid>;
  }

  public get(uuid: string): Observable<LicensedAgent> {
    return this.httpClient.get(`/rest/crm/affiliate-code/${uuid}`)
      .pipe(first()) as Observable<LicensedAgent>;
  }
}
